// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OJ3J","type":"styles_type__kvvxB","choices":"styles_choices__2sWar"};